import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { baseUrlFunc } from '../../app/app.module';
import { HttpInterceptorProvider } from '../http-interceptor/http-interceptor';

/*
  Generated class for the DocumentosProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EventsProvider {

  apiBase = baseUrlFunc() + "wp/v2/eventos"

  memoryCache

  constructor(public http: HttpInterceptorProvider) {
  }

  solicitarEventos(): Observable<any> {
    return Observable.create(observer => {

      if (this.memoryCache != undefined)
        observer.next(this.memoryCache)

      this.http.get(this.apiBase).subscribe(data => {
        observer.next(data)
        this.memoryCache = data
        console.log("Events success response", data)
      }, err => {
        observer.error(err)
        console.log("Events error response", err)
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/events/events.ts